<template>
  <div class="card shadow-sm mb-4">
    <div class="card-header bg-accent">
      <h4 class="mb-0 text-white fs-1vw">مدیریت دوره‌های آموزشی مرتبط با شایستگی</h4>
    </div>
    <div class="card-body">
      <div class="row mb-3 align-items-end">
        <div class="col-md-5">
          <label class="form-label fw-bold">قسمت</label>
          <select class="form-select" v-model="newItem.chapter">
            <option value="" disabled>قسمت را انتخاب کنید</option>
            <option v-for="(chapter, index) in chapters" :key="index" :value="chapter">
              {{ chapter }}
            </option>
          </select>
        </div>
        <div class="col-md-5">
          <label class="form-label fw-bold">عنوان</label>
          <input
              type="text"
              class="form-control"
              placeholder="عنوان را وارد کنید"
              v-model="newItem.title"
          />
        </div>
        <div class="col-md-2">
          <GeneralButton @clicked="addItem"/>
        </div>
      </div>
      <hr class="my-3">

      <!-- Items Table -->
      <GeneralTable
          :headers="['قسمت', 'عنوان']"
          :fields="['chapter', 'title']"
          :items="courses"
          :openEditModalMethod="openEditModal"
          @remove="removeItem"
      />

      <!-- Edit Item Modal -->
      <GeneralModal
          v-show="editedItem"
          title="ویرایش دوره آموزشی"
          modal-id="competencyModalId"
          @save="updateItem"
      >
        <div class="row mb-3">
          <div class="col-md-6">
            <label class="form-label fw-bold">قسمت</label>
            <select class="form-select" v-if="editedItem" v-model="editedItem.chapter">
              <option value="" disabled>قسمت را انتخاب کنید</option>
              <option v-for="(chapter, index) in chapters" :key="index" :value="chapter">
                {{ chapter }}
              </option>
            </select>
          </div>
          <div class="col-md-6">
            <label class="form-label fw-bold">عنوان</label>
            <input
                type="text"
                class="form-control"
                placeholder="عنوان را وارد کنید"
                v-if="editedItem"
                v-model="editedItem.title"
            />
          </div>
        </div>
      </GeneralModal>
    </div>
  </div>
</template>

<script>
import GeneralTable from "@/components/JobDescription/GeneralComponents/GeneralTable.vue";
import GeneralModal from "@/components/JobDescription/GeneralComponents/GeneralModal.vue";
import GeneralButton from "@/components/JobDescription/GeneralComponents/GeneralButton.vue";
import { Modal } from 'bootstrap';
import { useToast } from "vue-toastification";

const baseStructure = {
  chapter: '',
  title: '',
};

const toast = useToast();

export default {
  components: { GeneralTable, GeneralModal, GeneralButton },

  created() {
    this.$store.dispatch('crudActions/fetchInitialData', {
      endpoint: '/competency-courses/index',
      afterMutation: 'courses/setCourses'
    });
  },

  data() {
    return {
      newItem: structuredClone(baseStructure),
      chapters: [
        'دوره های آموزشی مرتبط با دانش‌های شغلی',
        'دوره های آموزشی مرتبط با توانایی های شغلی',
        'دوره های آموزشی مرتبط با مهارت های شغلی',
      ],
      editedItem: null,
      editIndex: null,
    };
  },

  computed: {
    courses: {
      get() {
        return this.$store.state.courses.courses;
      },
      set(value) {
        this.$store.commit('courses/setCourses', value);
      }
    },
  },

  methods: {
    async addItem() {
      if (!this.checkItemValidation(this.newItem)) {
        return;
      }

      const response = await this.$store.dispatch('crudActions/create', {
        resourceData: this.newItem,
        endpoint: '/competency-courses/store',
      });

      this.courses = [...this.courses, structuredClone(response.data)];
      this.newItem = structuredClone(baseStructure);
    },

    removeItem(index) {
      const course = this.courses.find((_, i) => i === index);
      this.courses = this.courses.filter((_, i) => i !== index);

      this.$store.dispatch('crudActions/delete', {
        resourceId: course.id,
        endpoint: '/competency-courses/delete',
      });
    },

    openEditModal(item, index) {
      this.editedItem = structuredClone(item);
      this.editIndex = index;
      const modal = Modal.getOrCreateInstance(document.getElementById('competencyModalId'));
      modal.show();
    },

    updateItem() {
      if (this.editIndex === null) {
        return;
      }

      if (!this.checkItemValidation(this.editedItem)) {
        return;
      }

      this.courses.splice(this.editIndex, 1, {...this.editedItem});

      this.$store.dispatch('crudActions/update', {
        resourceData: this.editedItem,
        endpoint: '/competency-courses/update',
      });

      this.editIndex = null;
      this.editedItem = null;
      const modal = Modal.getOrCreateInstance(document.getElementById('competencyModalId'));
      modal.hide();
    },

    checkItemValidation(item) {
      if (!item.chapter || !item.title) {
        toast.error('همه فیلدها را کامل وارد کنید!');
        return false;
      }
      return true;
    }
  }
};
</script>
